import React, { useState, useEffect } from "react";
import styles from "./OtherInfoMain.module.css";
import { useHistory } from "react-router-dom";

import Select, { components } from "react-select";
import { GoChevronDown } from "react-icons/go";


import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";

function OtherInfoMain(props) {
  useEffect(() => {
    if (props.passportDetails.application !== true) {
      history.push("/dashboard/my-applications");
    } else {
      setId(props.passportDetails.id);
      setGender(props.passportDetails.gender);
      
      if(props.passportDetails.religion !== undefined){
      setId(props.passportDetails.id);
      setGender(props.passportDetails.gender);
      setMaritalStatus({value: props.passportDetails.marital_status, label: props.passportDetails.marital_status})
      setProfession({value: props.passportDetails.profession, label: props.passportDetails.profession})
      setReligion({value: props.passportDetails.religion, label: props.passportDetails.religion})
      setHusbandName(props.passportDetails.husbands_name)
      setWifeName(props.passportDetails.wifes_name)
      setMotherName(props.passportDetails.mothers_name)
      setFatherName(props.passportDetails.fathers_name)
    }
    }
  }, []);


  console.log(props.passportDetails);

  const [maritalStatus, setMaritalStatus] = useState("");
  const [profession, setProfession] = useState("");




  const [religion, setReligion] = useState("");

  const [husbandName, setHusbandName] = useState("");
  const [wifeName, setWifeName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [fatherName, setFatherName] = useState("");

  const history = useHistory();
  const [id, setId] = useState("");

  const [gender, setGender] = useState("");

  const goLater = () => {
    alert("save and later");
  };

  console.log(maritalStatus.value)
  console.log(gender)
  console.log(props.passportDetails.gender)

  const go = () => {
    if(maritalStatus.value === undefined || profession.value === undefined || religion.value === undefined || motherName === "" || fatherName === ""){
       toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Field Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    else if((maritalStatus.value === "MARRIED") && (gender === "MALE") && (wifeName === "")){
         toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Field Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }   
    else if((maritalStatus.value === "MARRIED") && (gender === "FEMALE") && (husbandName === "")){
       toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Field Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }   
    else{
      const data = {
        ...props.passportDetails,
        marital_status: maritalStatus.value,
        profession: profession.value,
        religion: religion.value,
        mothers_name: motherName,
        fathers_name: fatherName,
        wifes_name: wifeName,
        husbands_name: husbandName,
        spouse_name: ((gender === "MALE" && maritalStatus.value === "MARRIED")? (wifeName) : (
          (
            gender === "FEMALE" && maritalStatus.value === "MARRIED"
          )?(
            husbandName
          ):
          "no"
          ))
        };

      // if(maritalStatus === "MARRIED"){
      //   if(gender === "MALE"){
      //     data.wifes_name: wifeName,
      //   }
      //   else if(gender === "FEMALE"){
      //     data.husbands_name: husbandName,
      //   }
      // }
      props.ChangePassportDetails(data);
      history.push(`/dashboard/my-applications/${id}/travel-info`)
    }
    
  };

  const options1 = [
    { value: "MARRIED", label: "Married" },
    { value: "SINGLE", label: "Single" },
    { value: "DIVORCED", label: "Divorced" },
    { value: "WIDOW", label: "Widow" },
    { value: "WIDOWER", label: "Widower" },
  ];

  const options2 = [
    { value: "EMPLOYER", label: "Employer" },
    { value: "EMPLOYEE", label: "Employee" },
    { value: "SELF_EMPLOYED", label: "Self Employed" },
    { value: "RETIRED", label: "Retired" },
    { value: "UNEMPLOYED", label: "Unemployed" },
    { value: "STUDENT", label: "Student" },
  ];

  const options3 = [
    { value: "ISLAM", label: "Islam" },
    { value: "CHRISTIANITY", label: "Christian" },
    { value: "OTHERS", label: "Others" },
  ];

  const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <GoChevronDown size={24} color="#1D1E1EA" />
      </components.DropdownIndicator>
    );
  };

  const style1 = {
    control: (base) => ({
      ...base,
      border: "1px solid #D1E1EA",
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      cursor: "pointer",
      height: "50px",
      borderRadius: "10px",
      "&:hover": {
        border: "1px solid #D1E1EA",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: 2,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        color: "#20313B",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  return (
    <div>
      <h2 className={styles.head}>Application Form</h2>
      <div className={styles.mainBox}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>2</p>
          <p className={styles.FirstText}>Other Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox}>
          <div className={styles.select}>
            <label for="Profession" className={styles.label}>
              Marital Status
            </label>
            <br />

            <Select
              id="Marital Status"
              styles={style1}
              placeholder={""}
              isSearchable={false}
              options={options1}
              value={maritalStatus}
              onChange={(e) => {
                setMaritalStatus(e);
              }}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  neutral50: "#000000",
                },
              })}
            />
          </div>
          <div className={styles.select}>
            <label for="Profession" className={styles.label}>
              Profession
            </label>
            <br />
            <Select
              id="Profession"
              styles={style1}
              placeholder={""}
              isSearchable={false}
              options={options2}
              value={profession}
              onChange={(e) => {
                setProfession(e);
              }}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  neutral50: "#000000",
                },
              })}
            />
          </div>

          <div className={styles.select}>
            <label for="Religion" className={styles.label}>
              Religion
            </label>
            <br />
            <Select
              id="Religion"
              styles={style1}
              placeholder={""}
              isSearchable={false}
              options={options3}
              value={religion}
              onChange={(e) => {
                setReligion(e);
              }}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  neutral50: "#000000",
                },
              })}
            />
          </div>
        </div>
        {/* <div className={styles.inputsBoxSecond}>
          <div>
            <label for="Religion" className={styles.label}>
              Religion
            </label>
            <br />
            <input
              type="text"
              id="Religion"
              className={styles.input}
              value={religion}
              onChange={(e) => setReligion(e.target.value)}
            />
          </div>
        </div> */}

        <div className={styles.inputsBox}>
          {maritalStatus.value === "MARRIED" ? (
            gender === "MALE" || gender === "male" ? (
              <div>
                <label for="Wife's Name" className={styles.label}>
                  Wife's Name
                </label>
                <br />
                <input
                  type="text"
                  id="Wife's Name"
                  className={styles.input}
                  value={wifeName}
                  onChange={(e) => setWifeName(e.target.value)}
                />
              </div>
            ) : gender === "FEMALE" || gender === "female" ? (
              <div>
                <label for="Husband's Name" className={styles.label}>
                  Husband's Name
                </label>
                <br />
                <input
                  type="text"
                  id="Husband's Name"
                  className={styles.input}
                  value={husbandName}
                  onChange={(e) => setHusbandName(e.target.value)}
                />
              </div>
            ) : null
          ) : null}

          <div>
            <label for="Mother's Name" className={styles.label}>
              Mother's Name
            </label>
            <br />
            <input
              type="text"
              id="Mother's Name"
              className={styles.input}
              value={motherName}
              onChange={(e) => setMotherName(e.target.value)}
            />
          </div>
          <div>
            <label for="Father's Name" className={styles.label}>
              Father's Name
            </label>
            <br />
            <input
              type="text"
              id="Father's Name"
              className={styles.input}
              value={fatherName}
              onChange={(e) => setFatherName(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.btns}>
          {/* <button className={styles.btn1} onClick={() => goLater()}>
            Save and continue later
          </button> */}
          <button className={styles.btn2} onClick={() => go()}>
            Continue
          </button>
        </div>
      </div>
      
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(OtherInfoMain);
